/* PawLab homepage Top Rated cards: swap main image from variant thumbnails + quick-add */
(function () {
  function setQuickAddLabel(button, kind) {
    if (!button) return;
    var label = button.querySelector(".pawlab-story__quick-add-label");
    var key = "label" + kind.charAt(0).toUpperCase() + kind.slice(1);
    var text = button.dataset[key];
    if (!text) return;
    button.setAttribute("aria-label", text);
    if (label) label.textContent = text;
  }

  function syncQuickAddFromThumb(card, thumb) {
    var qa = card.querySelector("[data-pawlab-quick-add]");
    if (!qa) return;
    if (thumb.dataset.variantId) {
      qa.dataset.variantId = thumb.dataset.variantId;
      card.dataset.variantId = thumb.dataset.variantId;
      var hidden = card.querySelector("[data-pawlab-quick-add-variant]");
      if (hidden) hidden.value = thumb.dataset.variantId;
    }
    var available = thumb.dataset.available !== "false";
    qa.disabled = !available;
    qa.classList.toggle("is-sold-out", !available);
    qa.classList.remove("is-loading", "is-error");
    setQuickAddLabel(qa, available ? "add" : "sold");
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector("cart-drawer-component");
    if (!drawer) return;
    if (typeof drawer.open === "function") drawer.open();
    else if (typeof drawer.showDialog === "function") drawer.showDialog();
  }

  function addSelectedVariant(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.disabled || button.classList.contains("is-loading")) return;
    button.classList.add("is-loading");
    button.classList.remove("is-error");
    button.disabled = true;
    setQuickAddLabel(button, "adding");

    var payload = { id: Number(variantId), quantity: 1 };
    var sections = cartSectionIds();
    if (sections.length) payload.sections = sections.join(",");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw result.data;
        }
        return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        button.classList.remove("is-loading");
        button.disabled = false;
        setQuickAddLabel(button, "added");
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: "pawlab-story-quick-add",
              data: {
                source: "pawlab-story-quick-add",
                itemCount: cart.item_count,
                productId: button.dataset.productId,
                variantId: String(variantId),
                sections: cart.sections
              }
            }
          })
        );
        openCartDrawer();
        window.setTimeout(function () {
          if (!button.classList.contains("is-sold-out")) setQuickAddLabel(button, "add");
        }, 1600);
      })
      .catch(function () {
        button.classList.remove("is-loading");
        button.classList.add("is-error");
        button.disabled = false;
        setQuickAddLabel(button, "error");
        window.setTimeout(function () {
          if (!button.classList.contains("is-sold-out")) setQuickAddLabel(button, "add");
        }, 2200);
      });
  }

  function bind(root) {
    root.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-pawlab-quick-add-form]");
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      var qa = form.querySelector("[data-pawlab-quick-add]");
      if (qa) addSelectedVariant(qa);
    });
    root.addEventListener("click", function (event) {
      var qa = event.target.closest("[data-pawlab-quick-add]");
      if (qa && root.contains(qa)) {
        event.preventDefault();
        event.stopPropagation();
        addSelectedVariant(qa);
        return;
      }
      var btn = event.target.closest(".pawlab-story__thumb");
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      event.stopPropagation();
      var card = btn.closest(".pawlab-story__product");
      if (!card) return;
      var img = card.querySelector(".pawlab-story__product-img img");
      if (img && btn.dataset.src) {
        img.src = btn.dataset.src;
        img.removeAttribute("srcset");
      }
      card.querySelectorAll(".pawlab-story__thumb").forEach(function (thumb) {
        var on = thumb === btn;
        thumb.classList.toggle("is-selected", on);
        thumb.setAttribute("aria-pressed", on ? "true" : "false");
      });
      card.querySelectorAll(".pawlab-story__product-main, .pawlab-story__product-img-link").forEach(function (link) {
        if (btn.dataset.variantUrl) link.href = btn.dataset.variantUrl;
      });
      var price = card.querySelector(".pawlab-story__product-price");
      if (price && btn.dataset.price) price.textContent = btn.dataset.price;
      syncQuickAddFromThumb(card, btn);
    });
  }

  function init() {
    document.querySelectorAll("[data-pawlab-thumbs]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
